export default {
    namespaced: true,
    state: {
        width: window && window.innerWidth,
        height: window && window.innerHeight,
        orientation: 'landscape',
    },
    getters: {
        size: state => ({
            width: state.width,
            height: state.height,
        }),
        orientation: state => state.orientation,
        
        isMobile: state => state.width < 768, // CSS
        isTabletPortrait: state => state.orientation.includes('portrait'),
        isTabletLandscape: state => state.orientation.includes('landscape'),
    },
    mutations: {
        setSizing(state, {width, height}) {
            if ( !width || !height ) 
                return;

            state.width = width
            state.height = height
        },
        setOrientation(state, payload = 'landscape') {
            if ( typeof payload === 'string' )
                state.orientation = payload
        },
    },
    actions: {
        setupBrowser({ commit }, { width, height, orientation }) {
            return new Promise(resolve => {
                commit('setSizing', { width, height })
                commit('setOrientation', orientation)
                resolve()
            })
        },
    }
}